<template>
    <!-- Wing Tab Navigation -->
    <div class="section pt-1 mt-2">
        <div class="wallet-card">
            <div class="wallet-footer">
                <ul class="nav nav-tabs lined" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '1' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('1')">
                            {{ $t('wisdom') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '2' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('2')">
                            {{ $t('youth') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '3' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('3')">
                            {{ $t('students') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '4' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('4')">
                            {{ $t('women') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '6' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('6')">
                            {{ $t('girls') }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <!-- Filter Section with Accordion -->
    <div class="section inset mt-1 mb-1" v-if="!loading">
        <div class="accordion" id="accordionExample2">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#accordion001" aria-expanded="false">
                        <ion-icon name="filter-outline" role="img" class="md hydrated"
                            aria-label="wallet outline"></ion-icon>
                        Filter
                    </button>
                </h2>
                <div id="accordion001" class="accordion-collapse collapse" :class="hasActiveFilters ? 'show' : ''"
                    data-bs-parent="#accordionExample2" style="">
                    <div class="accordion-body">
                        <div id="search" style="padding: 0px !important;">
                            <!-- District Filter (State Admins only) -->
                            <div v-if="showDistrictFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_district">{{ $t('district') }}</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.district"
                                        name="filter_district" id="filter_district" @change="onDistrictChange">
                                        <option value>---All---</option>
                                        <option v-for="d in districtsList" v-bind:value="d.id" v-bind:key="d.id">{{ d.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <!-- Zone Filter (for State and District Admins) -->
                            <div v-if="showZoneFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_zone">{{ $t('zone') }}</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.zone"
                                        name="filter_zone" id="select4" @change="onZoneChange">
                                        <option value>---All---</option>
                                        <option v-for="zone in zonesList" v-bind:value="zone.id" v-bind:key="zone.id">{{
                                            zone.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Designation/Position Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_position">{{ $t('designation') }}</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.position"
                                        name="filter_position" id="select4">
                                        <option value>---All---</option>
                                        <option v-for="position in positionsList" v-bind:value="position.id" v-bind:key="position.id">{{
                                            position.value_mal || position.value }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Department Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_department">{{ $t('department') }}</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.department"
                                        name="filter_department" id="select5" @change="onDepartmentChange">
                                        <option value>---All---</option>
                                        <option v-for="department in departmentsList" v-bind:value="department.id" v-bind:key="department.id">{{
                                            department.name_mal || department.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;"
                                        @click="clearFilters()">
                                        <ion-icon name="trash-bin-outline" role="img" class="md hydrated"
                                            aria-label="add outline"></ion-icon>
                                        Clear
                                    </button>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;"
                                        @click="applyFilters()">
                                        <ion-icon name="search-outline" role="img" class="md hydrated"
                                            aria-label="add outline"></ion-icon>
                                        Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Search Box -->
    <div id="search">
        <form class="search-form">
            <div class="form-group searchbox">
                <input type="text" class="form-control" :placeholder="$t('search')" v-model="searchQuery"
                    @input="filteredExecutives()">
                <i class="input-icon">
                    <ion-icon name="search-outline"></ion-icon>
                </i>
            </div>
        </form>
    </div>

    <!-- Loading -->
    <div class="section text-center mt-2" v-if="loading">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <!-- Summary Stats -->
    <div class="section" v-if="!loading && hierarchicalData.length > 0 && showTotalExecutivesCard">
        <div class="row mt-1">
            <div class="col-12">
                <div class="stat-box">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <div class="title mal-text text-primary">{{ $t('total_executives') }}</div>
                            <div class="value text-dark"><span class="text-primary">{{ totalExecutives }}</span></div>
                        </div>
                        <button type="button" class="btn btn-success btn-sm" @click="shareViaWhatsApp" 
                                v-if="totalExecutives > 0">
                            <ion-icon name="logo-whatsapp"></ion-icon>
                            Share
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Share Button for Zone Admins (when total card is hidden) -->
    <div class="section" v-if="!loading && hierarchicalData.length > 0 && !showTotalExecutivesCard">
        <div class="row mt-1">
            <div class="col-12">
                <button type="button" class="btn btn-success btn-sm w-100" @click="shareViaWhatsApp" 
                        v-if="totalExecutives > 0">
                    <ion-icon name="logo-whatsapp"></ion-icon>
                    Share List ({{ totalExecutives }} {{ $t('executives') }})
                </button>
            </div>
        </div>
    </div>

    <!-- Hierarchical Executive List (Zone -> Executives) -->
    <div v-for="zone in hierarchicalData" :key="zone.id" class="zone-section">
        <!-- Zone Header -->
        <div class="zone-header">
            <div class="listview-title mt-1 mb-1 mal-text text-primary" style="font-size: 15px; font-weight: bold;">
                {{ zone.name }} ({{ zone.executives.length }} {{ $t('executives') }})
            </div>
        </div>
        
        <!-- Executives List for this Zone -->
        <ul class="listview image-listview inset text mt-0 mb-1" v-if="zone.executives.length > 0">
            <li v-for="(executive, index) in zone.executives" :key="executive.id">
                <a href="javascript:void(0)" class="item">
                    <span class="sl-no">{{ index + 1 }}</span>
                    <div class="avatar-section">
                        <a href="#">
                            <img v-if="executive.member && executive.member.avatar && executive.member.avatar !== 'member.jpg'" 
                                 :src="'https://guide.msoftit.com/' + executive.member.avatar" 
                                 alt="avatar" class="image">
                            <img v-else 
                                 src="assets/img/sample/avatar/avatar1.png" 
                                 alt="avatar" class="image">
                        </a>
                    </div>
                    <div class="in">
                        <div class="min-width-50">
                            <b>{{ executive.member ? executive.member.name : 'N/A' }}</b>
                            <footer>
                                <!-- Contact Information -->
                                <template v-if="shouldShowContactInfo(executive)">
                                    <span v-if="executive.member && executive.member.mobile">
                                        {{ executive.member.country_code }} {{ executive.member.mobile }}
                                    </span>
                                    <span v-if="executive.member && executive.member.whatsapp_number">
                                        <br>WhatsApp: {{ executive.member.whatsapp_country_code || executive.member.country_code }} {{ executive.member.whatsapp_number }}
                                    </span>
                                    <br v-if="executive.user_sublevel_desc && (executive.member?.mobile || executive.member?.whatsapp_number)">
                                </template>
                                
                                <!-- Designation -->
                                <span v-if="executive.user_sublevel_desc || executive.designation">
                                    <strong class="text-primary">{{ 
                                        ((executive.designation && executive.designation.toLowerCase().includes('state councillor')) || 
                                         (executive.user_sublevel_desc && executive.user_sublevel_desc.toLowerCase().includes('state councillor'))) 
                                            ? (executive.comments && executive.comments.trim() ? executive.comments.trim() : 'State Councillor')
                                            : (executive.user_sublevel_desc || executive.designation)
                                    }}</strong>
                                </span>
                                
                                <!-- Departments -->
                                <span v-if="executive.departments && executive.departments.length > 0">
                                    <br v-if="executive.user_sublevel_desc || (shouldShowContactInfo(executive) && (executive.member?.mobile || executive.member?.whatsapp_number))"><em class="text-muted">
                                        <span v-for="(dept, deptIndex) in executive.departments" :key="dept.id">
                                            {{ dept.name_mal || dept.name }}<span v-if="deptIndex < executive.departments.length - 1">, </span>
                                        </span>
                                    </em>
                                </span>
                            </footer>
                        </div>
                        
                        <!-- Action Button - Only show for Women's and Girls' wing members -->
                        <div class="card-button dropdown" v-if="canShowActionModal">
                            <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                                :data-bs-target="'#actionSheetInset'+executive.id">
                                <ion-icon name="ellipsis-horizontal"></ion-icon>
                            </button>
                        </div>
                    </div>
                </a>
                
                <!-- Action Sheet Modal - Only render for Women's and Girls' wing members -->
                <div class="modal fade action-sheet" :id="'actionSheetInset'+executive.id" tabindex="-1" role="dialog" v-if="canShowActionModal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Action</h5>
                            </div>
                            <div class="modal-body">
                                <ul class="action-button-list">
                                    <li v-if="executive.member && executive.member.mobile">
                                        <a :href="'tel:' + (executive.member.country_code || '+91') + executive.member.mobile" class="btn btn-list">
                                            <span>
                                                <ion-icon name="call-outline"></ion-icon> Call
                                            </span>
                                        </a>
                                    </li>
                                    <li v-if="executive.member && (executive.member.whatsapp_number || executive.member.mobile)">
                                        <a :href="'https://wa.me/' + (executive.member.whatsapp_country_code || executive.member.country_code || '91') + (executive.member.whatsapp_number || executive.member.mobile) + '?text='" 
                                           class="btn btn-list">
                                            <span>
                                                <ion-icon name="logo-whatsapp"></ion-icon> WhatsApp
                                            </span>
                                        </a>
                                    </li>
                                    <li class="action-divider"></li>
                                    <li>
                                        <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                            <span>
                                                <ion-icon name="close-outline"></ion-icon> Cancel
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        
        <!-- No executives message for zone -->
        <div v-if="zone.executives.length === 0" class="text-center p-2 text-muted">
            <em>{{ $t('no_executives_in_zone') }}</em>
        </div>
        
        <!-- Zone Separator (except for last zone) -->
        <div v-if="hierarchicalData.indexOf(zone) < hierarchicalData.length - 1" class="zone-bottom-separator"></div>
    </div>

    <!-- No Data Message -->
    <div v-if="!loading && hierarchicalData.length === 0" class="text-center p-4">
        <p class="text-muted">{{ $t('no_executives_found') }}</p>
    </div>

    <!-- Pagination Component -->
    <div class="section mt-2" v-if="!loading && !executivesLoading && executivesData && executivesData.total > 0">
        <vue-awesome-paginate 
            v-if="executivesData.total > executivesData.per_page"
            :total-items="executivesData.total" 
            :items-per-page="executivesData.per_page"
            :max-pages-shown="3" 
            v-model="executivesData.current_page" 
            :on-click="onPaginationClick"
            :show-ending-buttons="true" 
            :show-breakpoint-buttons="false" />
    </div>
</template>

<script>
import UserService from "../../services/user.service";
import { mapState } from "vuex";

export default {
    name: "ZoneExecutiveList",
    
    data() {
        return {
            loading: false,
            hierarchicalData: [],
            originalHierarchicalData: [],
            originalExecutivesData: [],
            totalExecutives: 0,
            searchQuery: '',
            
            // Pagination data
            executivesData: {
                data: [],
                total: 0,
                per_page: 20,
                current_page: 1,
                last_page: 1,
                from: 0,
                to: 0
            },
            executivesLoading: false,
            allComprehensiveData: [],
            isClientSidePagination: false,
            
            // Filter data
            filters: {
                wing: '',
                district: '',
                zone: '',
                position: '',
                department: ''
            },
            
            // Dropdown lists
            districtsList: [],
            zonesList: [],
            positionsList: [
                { id: '1', value: 'President', value_mal: 'പ്രസിഡന്റ്' },
                { id: '2', value: 'Vice President', value_mal: 'വൈസ് പ്രസിഡന്റ്' },
                { id: '3', value: 'General Secretary', value_mal: 'ജനറൽ സെക്രെട്ടറി' },
                { id: '4', value: 'Joint Secretary', value_mal: 'ജോയിന്റ് സെക്രെട്ടറി' },
                { id: '5', value: 'Treasurer', value_mal: 'ട്രഷറർ' },
                { id: '6', value: 'Executive Member', value_mal: 'എക്സിक्यൂട്ടീവ് മെമ്പർ' },
            ],
            departmentsList: [],
        };
    },

    computed: {
        ...mapState({
            currentUser: state => state.auth.user
        }),
        
        hasActiveFilters() {
            return this.filters.district || this.filters.zone || this.filters.position || this.filters.department;
        },
        
        filterCount() {
            let count = 0;
            if (this.filters.district) count++;
            if (this.filters.zone) count++;
            if (this.filters.position) count++;
            if (this.filters.department) count++;
            return count;
        },
        
        showDistrictFilter() {
            // District filter should show only for State Admins (level 1)
            if (!this.currentUser) {
                return false;
            }
            const userLevel = parseInt(this.currentUser.user_level);
            return userLevel === 1;
        },
        
        showZoneFilter() {
            // Zone filter should show for State Admins (level 1) and District Admins (level 2)
            if (!this.currentUser) {
                return false;
            }
            
            const userLevel = parseInt(this.currentUser.user_level);
            return userLevel === 1 || userLevel === 2;
        },
        
        showTotalExecutivesCard() {
            // Hide total executives card for Zone Admins (level 3)
            if (!this.currentUser) {
                return false;
            }
            
            const userLevel = parseInt(this.currentUser.user_level);
            return userLevel !== 3;
        },
        
        canShowActionModal() {
            // Show 3-dot modal based on user's wing and current viewing wing
            if (!this.currentUser) {
                return false;
            }
            
            const userWing = this.currentUser.wing;
            const currentViewingWing = this.filters.wing;
            
            // Women's (4) and Girls' (6) members: can see 3-dot buttons on ALL wings
            if (userWing === 4 || userWing === 6) {
                return true;
            }
            
            // Org (1), Youth (2), Students (3) members: can see 3-dot buttons on Org, Youth, and Students wings only
            if (userWing === 1 || userWing === 2 || userWing === 3) {
                return currentViewingWing === '1' || currentViewingWing === '2' || currentViewingWing === '3';
            }
            
            return false;
        },
        
        shouldShowContactInfo() {
            return (executive) => {
                if (!this.currentUser) {
                    return false;
                }
                
                const userWing = this.currentUser.wing;
                const executiveWing = executive.wing_id || executive.wing || executive.wing_type;
                
                // Org (1), Youth (2), Students (3) members: cannot see Women's (4) and Girls' (6) contact info
                if (userWing === 1 || userWing === 2 || userWing === 3) {
                    return executiveWing !== 4 && executiveWing !== '4' && executiveWing !== 6 && executiveWing !== '6';
                }
                
                // Women's (4) and Girls' (6) members: can see all contact info
                if (userWing === 4 || userWing === 6) {
                    return true;
                }
                
                return true;
            };
        }
    },

    watch: {
        '$route'(to, from) {
            if (to.path !== from.path) {
                this.zonesList = [];
                this.loadExecutivesList(1);
            }
        }
    },

    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            // Set default wing to Wisdom (1)
            this.filters.wing = '1';
            this.initializeComponent();
            this.$root.updateParent(this.$t('zone_level_executives'));
        }
    },

    methods: {
        initializeComponent() {
            // Parse URL to get district/zone context for initial data loading
            const urlPath = this.$route.path;
            const pathParts = urlPath.split('/').filter(p => p);
            let urlExtractedDistrictId = null;
            
            if (pathParts.length >= 3 && pathParts[0] === 'org') {
                const urlUserLevel = parseInt(pathParts[1]);
                const urlTargetId = parseInt(pathParts[2]);
                
                if (urlUserLevel === 2) {
                    // District Admin level - target ID is district_id
                    urlExtractedDistrictId = urlTargetId;
                }
            }
            
            this.loadInitialData(urlExtractedDistrictId);
            this.loadExecutivesList(1);
        },

        async loadInitialData(targetDistrictId = null) {
            try {
                // Load districts for state admins (for filtering)
                if (this.currentUser.user_level === 1) {
                    await this.loadDistrictsList();
                }

                // Load zones for state and district admins (for filtering)
                if (this.currentUser.user_level === 1 || this.currentUser.user_level === 2) {
                    // If state admin picked district, prefer that; otherwise use URL-extracted district (for district admin deep link)
                    const districtToUse = (this.currentUser.user_level === 1 && this.filters.district) 
                        ? this.filters.district 
                        : targetDistrictId;
                    await this.loadZonesList(districtToUse);
                }
                
                // Load departments for current wing
                await this.loadDepartmentsList();
            } catch (error) {
                // Silent error handling
            }
        },

        async loadDistrictsList() {
            try {
                const response = await UserService.authPostRequest('get-district-by-id', {});
                if (response.data.status === 'success' && response.data.data) {
                    const list = response.data.data.list;
                    this.districtsList = Array.isArray(list) ? list : (list && typeof list === 'object' ? [list] : []);
                } else {
                    this.districtsList = [];
                }
            } catch (error) {
                this.districtsList = [];
            }
        },

        async loadZonesList(targetDistrictId = null) {
            try {
                // If we have a specific district ID from URL, use it
                if (targetDistrictId) {
                    const response = await UserService.authPostRequest('get-zone-by-id', {
                        district_id: targetDistrictId
                    });
                    
                    if (response.data.status === 'success') {
                        this.zonesList = response.data.data.list || [];
                        return;
                    }
                }
                
                // Try multiple approaches to get zones
                const zoneAttempts = [
                    { params: {} },
                    { params: { user_level: 1, get_all: true } },
                    { params: { scope: 'state', level: 'all' } },
                    { params: { all_districts: true } }
                ];
                
                for (const attempt of zoneAttempts) {
                    try {
                        const response = await UserService.authPostRequest('get-zone-by-id', attempt.params);
                        
                        if (response.data.status === 'success' && response.data.data.list && response.data.data.list.length > 0) {
                            this.zonesList = response.data.data.list || [];
                            return;
                        }
                    } catch (attemptError) {
                        // Continue to next attempt
                    }
                }
                
                // Fallback: user's district only
                const response = await UserService.authPostRequest('get-zone-by-id', {
                    district_id: this.currentUser.district_id
                });
                
                if (response.data.status === 'success') {
                    this.zonesList = response.data.data.list || [];
                }
                
            } catch (error) {
                this.zonesList = [];
            }
        },

        async loadDepartmentsList() {
            try {
                let data = {
                    wing: this.filters.wing,
                    user_level: 3,
                    level_id: this.currentUser.zone_id || this.currentUser.district_id
                };
                
                let response = await UserService.authPostRequest('get-departments', data);
                
                if (response.data.status === 'success' && response.data.data.list.length > 0) {
                    this.departmentsList = response.data.data.list;
                    return;
                }
                
                // Fallback: try without level_id
                data = {
                    wing: this.filters.wing,
                    user_level: 3
                };
                
                response = await UserService.authPostRequest('get-departments', data);
                
                if (response.data.status === 'success') {
                    this.departmentsList = response.data.data.list || [];
                } else {
                    this.departmentsList = [];
                }
            } catch (error) {
                this.departmentsList = [];
            }
        },

        async getUserLocationNames() {
            // Get location names for display purposes if not already available
            if (!this.currentUser.district_name && this.currentUser.district_id) {
                try {
                    const response = await UserService.authPostRequest('get-district-by-id', {});
                    if (response.data.status === 'success') {
                        const districts = response.data.data.list || [];
                        const currentDistrict = districts.find(d => d.id == this.currentUser.district_id);
                        if (currentDistrict) {
                            this.currentUser.district_name = currentDistrict.name;
                        }
                    }
                } catch (error) {
                    // Silent error handling
                }
            }
            
            if (!this.currentUser.zone_name && this.currentUser.zone_id) {
                try {
                    const response = await UserService.authPostRequest('get-zone-by-id', {
                        district_id: this.currentUser.district_id
                    });
                    if (response.data.status === 'success') {
                        const zones = response.data.data.list || [];
                        const currentZone = zones.find(z => z.id == this.currentUser.zone_id);
                        if (currentZone) {
                            this.currentUser.zone_name = currentZone.name;
                        }
                    }
                } catch (error) {
                    // Silent error handling
                }
            }
        },

        async loadExecutivesList(page = 1) {
            this.executivesLoading = true;
            this.loading = true;
            try {
                // Extract district ID and zone ID from URL FIRST
                const urlPath = this.$route.path;
                const pathParts = urlPath.split('/').filter(p => p);
                let urlExtractedDistrictId = null;
                let urlExtractedZoneId = null;
                
                if (pathParts.length >= 3 && pathParts[0] === 'org') {
                    const urlUserLevel = parseInt(pathParts[1]);
                    const urlTargetId = parseInt(pathParts[2]);
                    
                    if (urlUserLevel === 2) {
                        // District Admin level - target ID is district_id
                        urlExtractedDistrictId = urlTargetId;
                    } else if (urlUserLevel === 3) {
                        // Zone Admin level - target ID is zone_id
                        urlExtractedZoneId = urlTargetId;
                    }
                }
                
                await this.getUserLocationNames();
                
                // Build API parameters for zone-level executives
                const executiveParams = {};
                
                executiveParams.wing = this.filters.wing || '1';
                executiveParams.language = 'ml';
                executiveParams.term = 2;
                executiveParams.user_level = 3; // Zone level executives
                
                // Determine target zone ID
                let targetZoneId = null;
                let targetDistrictId = null;
                
                if (this.currentUser.user_level === 1) {
                    // State Admin
                    if (this.filters.zone && this.zonesList.length > 0) {
                        const selectedZone = this.zonesList.find(z => z.id == this.filters.zone);
                        if (selectedZone) {
                            targetZoneId = selectedZone.id;
                            targetDistrictId = selectedZone.district_id;
                        }
                    }
                } else if (this.currentUser.user_level === 2) {
                    // District Admin
                    if (this.filters.zone && this.zonesList.length > 0) {
                        const selectedZone = this.zonesList.find(z => z.id == this.filters.zone);
                        if (selectedZone) {
                            targetZoneId = selectedZone.id;
                            targetDistrictId = selectedZone.district_id;
                        }
                    }
                } else if (this.currentUser.user_level === 3) {
                    // Zone Admin - use their zone or URL extracted zone
                    targetZoneId = urlExtractedZoneId || this.currentUser.zone_id;
                }
                
                // Set API parameters
                if (this.currentUser.user_level === 1 && !targetZoneId) {
                    // State Admin - either filter by district (all zones in district) or get all zones
                    if (this.filters.district) {
                        const districtIdToUse = this.filters.district;
                        executiveParams.district_id = districtIdToUse;
                        executiveParams.force_district_id = districtIdToUse;
                        executiveParams.target_district = districtIdToUse;
                        executiveParams.get_all_zones_in_district = true;
                        executiveParams.admin_level_override = 1;
                        executiveParams.state_admin_access = true;
                        executiveParams.state_admin_district_filter = true;
                    } else {
                        executiveParams.get_all_zones = true;
                        executiveParams.admin_level_override = 1;
                        executiveParams.state_admin_access = true;
                    }
                } else if (this.currentUser.user_level === 2 && !targetZoneId) {
                    // District Admin - Get all zones from their district
                    // Use URL extracted district_id if available, otherwise use current user's district_id
                    const districtIdToUse = urlExtractedDistrictId || this.currentUser.district_id;
                    executiveParams.district_id = districtIdToUse;
                    executiveParams.force_district_id = districtIdToUse;
                    executiveParams.target_district = districtIdToUse;
                    executiveParams.get_all_zones_in_district = true;
                    executiveParams.admin_level_override = 2;
                    executiveParams.district_admin_access = true;
                } else {
                    // Specific zone selected or zone admin
                    if (targetZoneId) {
                        executiveParams.zone_id = targetZoneId;
                        executiveParams.force_zone_id = targetZoneId;
                        executiveParams.target_zone = targetZoneId;
                    }
                    if (targetDistrictId) {
                        executiveParams.district_id = targetDistrictId;
                        executiveParams.force_district_id = targetDistrictId;
                        executiveParams.target_district = targetDistrictId;
                    }
                }
                
                // Request parameters for comprehensive data
                executiveParams.scope = 'zone';
                executiveParams.level = 'zone';
                executiveParams.get_zone_executives = true;
                executiveParams.admin_mode = true;
                
                // Set pagination parameters
                executiveParams.page = page;
                executiveParams.no_limit = true;
                executiveParams.unlimited = true;
                executiveParams.get_all_records = true;
                executiveParams.override_limit = true;
                executiveParams.limit = 10000;
                executiveParams.per_page = 10000;
                
                // Add department filter to API request if selected
                if (this.filters.department) {
                    executiveParams.department_id = this.filters.department;
                }
                
                executiveParams.request_source = 'ZoneExecutiveList_' + Date.now();
                
                // Override with URL extracted district_id if present (for district admin viewing specific district)
                if (urlExtractedDistrictId) {
                    executiveParams.district_id = urlExtractedDistrictId;
                    executiveParams.force_district_id = urlExtractedDistrictId;
                    executiveParams.target_district = urlExtractedDistrictId;
                    executiveParams.admin_district_override = urlExtractedDistrictId;
                    executiveParams.url_district_id = urlExtractedDistrictId;
                    executiveParams.override_user_district = urlExtractedDistrictId;
                    
                    // Remove zone-specific overrides when filtering by district
                    delete executiveParams.get_all_zones;
                    delete executiveParams.state_admin_access;
                }
                
                // Override with URL extracted zone if present
                if (urlExtractedZoneId) {
                    executiveParams.zone_id = urlExtractedZoneId;
                    executiveParams.force_zone_id = urlExtractedZoneId;
                    executiveParams.target_zone = urlExtractedZoneId;
                    executiveParams.admin_zone_override = urlExtractedZoneId;
                    executiveParams.url_zone_id = urlExtractedZoneId;
                    executiveParams.override_user_zone = urlExtractedZoneId;
                    
                    // Remove district-specific overrides when filtering by specific zone
                    delete executiveParams.get_all_zones_in_district;
                    delete executiveParams.district_admin_access;
                }
                
                // Use the dedicated zone executives API endpoint
                let response = await UserService.authPostRequest('get-zone-executives-data', executiveParams);
                
                if (response && response.data && (response.data.success || response.data.status === 'success')) {
                    const isComprehensiveView = (this.currentUser.user_level <= 2) && (!targetZoneId);
                    
                    // Handle paginated response structure
                    if (response.data.data && typeof response.data.data === 'object' && response.data.data.data) {
                        const responseData = response.data.data.data || [];
                        
                        if (isComprehensiveView) {
                            const defaultPerPage = 20;
                            this.allComprehensiveData = responseData;
                            this.isClientSidePagination = true;
                            
                            const firstPageData = responseData.slice(0, defaultPerPage);
                            this.executivesData = {
                                data: firstPageData,
                                total: responseData.length,
                                per_page: defaultPerPage,
                                current_page: 1,
                                last_page: Math.ceil(responseData.length / defaultPerPage),
                                from: 1,
                                to: Math.min(defaultPerPage, responseData.length)
                            };
                        } else {
                            this.allComprehensiveData = [];
                            this.isClientSidePagination = false;
                            
                            this.executivesData = {
                                data: responseData,
                                total: response.data.data.total || 0,
                                per_page: response.data.data.per_page || 20,
                                current_page: response.data.data.current_page || 1,
                                last_page: response.data.data.last_page || 1,
                                from: response.data.data.from || 0,
                                to: response.data.data.to || 0
                            };
                        }
                    } else {
                        // Simple array response
                        const allData = Array.isArray(response.data.data) ? response.data.data : (response.data.data?.list || []);
                        
                        if (isComprehensiveView) {
                            this.executivesData = {
                                data: allData,
                                total: allData.length,
                                per_page: allData.length,
                                current_page: 1,
                                last_page: 1,
                                from: 1,
                                to: allData.length
                            };
                        } else {
                            const perPage = 20;
                            const totalItems = response.data.total || allData.length;
                            const totalPages = Math.ceil(totalItems / perPage);
                            const startIndex = (page - 1) * perPage;
                            const endIndex = startIndex + perPage;
                            const pageData = allData.slice(startIndex, endIndex);
                            
                            this.executivesData = {
                                data: pageData,
                                total: totalItems,
                                per_page: perPage,
                                current_page: page,
                                last_page: totalPages,
                                from: startIndex + 1,
                                to: Math.min(endIndex, totalItems)
                            };
                        }
                    }
                    
                    // Client-side wing filtering
                    const expectedWingFilter = this.filters.wing || '1';
                    const wingFilteredData = this.executivesData.data.filter(executive => {
                        const executiveWing = executive.wing_id || executive.wing || executive.wing_type || '1';
                        return executiveWing.toString() === expectedWingFilter;
                    });
                    
                    if (wingFilteredData.length !== this.executivesData.data.length) {
                        this.executivesData.data = wingFilteredData;
                        this.executivesData.total = wingFilteredData.length;
                        this.executivesData.to = wingFilteredData.length;
                    }
                    
                    // Filter out regular "Member" entries - only show Executive Members
                    const executiveOnlyData = this.filterExecutiveMembersOnly(this.executivesData.data);
                    
                    if (executiveOnlyData.length !== this.executivesData.data.length) {
                        this.executivesData.data = executiveOnlyData;
                        this.executivesData.total = executiveOnlyData.length;
                        this.executivesData.to = executiveOnlyData.length;
                    }
                    
                    // Transform data to hierarchical structure (Zone -> Executives)
                    this.hierarchicalData = this.transformToHierarchical(this.executivesData.data);
                    this.totalExecutives = this.executivesData.total;
                    this.originalExecutivesData = [...this.executivesData.data];
                    this.populateFilterDropdownsFromData(this.executivesData.data);
                } else {
                    // No data found
                    this.executivesData = {
                        data: [],
                        total: 0,
                        per_page: 20,
                        current_page: 1,
                        last_page: 1,
                        from: 0,
                        to: 0
                    };
                    this.hierarchicalData = [];
                    this.totalExecutives = 0;
                }
                
            } catch (error) {
                this.executivesData = {
                    data: [],
                    total: 0,
                    per_page: 20,
                    current_page: 1,
                    last_page: 1,
                    from: 0,
                    to: 0
                };
                this.hierarchicalData = [];
                this.totalExecutives = 0;
            } finally {
                this.executivesLoading = false;
                this.loading = false;
            }
        },

        populateFilterDropdownsFromData(executiveData) {
            if (!executiveData || !Array.isArray(executiveData) || executiveData.length === 0) {
                return;
            }
            
            // Extract unique zones from executive data
            const uniqueZones = [];
            const zoneIds = new Set();
            
            executiveData.forEach(executive => {
                if (executive.zone_id && executive.zone_name && !zoneIds.has(executive.zone_id)) {
                    uniqueZones.push({
                        id: executive.zone_id,
                        name: executive.zone_name,
                        district_id: executive.district_id,
                        district_name: executive.district_name
                    });
                    zoneIds.add(executive.zone_id);
                }
            });
            
            // Extract unique positions/designations from executive data
            const uniquePositions = [];
            const positionTexts = new Set();
            let positionIdCounter = 1;
            
            executiveData.forEach(executive => {
                const designation = executive.designation || executive.user_sublevel_desc || '';
                if (designation && !positionTexts.has(designation)) {
                    uniquePositions.push({
                        id: positionIdCounter.toString(),
                        value: designation,
                        value_mal: designation
                    });
                    positionTexts.add(designation);
                    positionIdCounter++;
                }
            });
            
            // Update the zones and positions lists
            if (this.zonesList.length === 0 || uniqueZones.length > 0) {
                this.zonesList = uniqueZones.sort((a, b) => a.name.localeCompare(b.name));
            }
            this.positionsList = uniquePositions.sort((a, b) => a.value.localeCompare(b.value));
        },

        // Helper function to filter out regular "Member" entries - only show Executive Members
        filterExecutiveMembersOnly(executives) {
            if (!executives || !Array.isArray(executives)) {
                return [];
            }
            
            return executives.filter(executive => {
                const designation = (executive.designation || executive.user_sublevel_desc || '').toLowerCase().trim();
                
                // Exclude entries that are just "Member" or "മെമ്പർ" (Member in Malayalam)
                // But include "Executive Member", "എക്സിക്യൂട്ടീവ് മെമ്പർ", and other executive designations
                if (!designation) {
                    return false; // Exclude entries with no designation
                }
                
                // Exclude if designation is exactly "member" or "മെമ്പർ"
                if (designation === 'member' || designation === 'മെമ്പർ') {
                    return false;
                }
                
                // Include all other designations (Executive Member, President, etc.)
                return true;
            });
        },

        transformToHierarchical(flatData) {
            if (!flatData || !Array.isArray(flatData) || flatData.length === 0) {
                return [];
            }
            
            const zonesMap = new Map();
            
            flatData.forEach((executive) => {
                const zoneKey = executive.zone_name || 'Unknown Zone';
                
                if (!zonesMap.has(zoneKey)) {
                    zonesMap.set(zoneKey, {
                        id: executive.zone_id,
                        name: zoneKey,
                        executives: []
                    });
                }
                
                const zone = zonesMap.get(zoneKey);
                
                // Transform API data to executive structure
                // Console log to check State Councillor data
                if (executive.user_sublevel_desc && executive.user_sublevel_desc.toLowerCase().includes('state councillor')) {
                    console.log('State Councillor found:', {
                        id: executive.id,
                        name: executive.member_name,
                        user_sublevel_desc: executive.user_sublevel_desc,
                        comments: executive.comments,
                        comments_trimmed: executive.comments ? executive.comments.trim() : '',
                        final_display: executive.comments && executive.comments.trim() ? executive.comments.trim() : 'State Councillor'
                    });
                }
                
                zone.executives.push({
                    id: executive.id,
                    wing: executive.wing,
                    wing_name: executive.wing_name,
                    designation: executive.designation,
                    user_sublevel_desc: executive.user_sublevel_desc || executive.designation,
                    user_sublevel: executive.user_sublevel,
                    comments: executive.comments || '',
                    departments: executive.departments ? 
                        (Array.isArray(executive.departments) ? executive.departments : 
                         executive.departments.split(', ').map(name => ({ name }))) : [],
                    member: {
                        name: executive.member_name,
                        mobile: executive.member_phone ? executive.member_phone.replace(/\+\d+\s*/, '') : '',
                        country_code: executive.member_phone && executive.member_phone.startsWith('+91') ? '+91' : '+91',
                        whatsapp_number: executive.member_phone ? executive.member_phone.replace(/\+\d+\s*/, '') : '',
                        whatsapp_country_code: executive.member_phone && executive.member_phone.startsWith('+91') ? '+91' : '+91',
                        avatar: executive.avatar || null
                    },
                    district_name: executive.district_name,
                    zone_name: executive.zone_name,
                    created_at: executive.created_at,
                    updated_at: executive.updated_at
                });
            });
            
            // Convert map to array
            const result = Array.from(zonesMap.values());
            
            return result;
        },

        calculateTotalExecutives() {
            let total = 0;
            this.hierarchicalData.forEach(zone => {
                total += zone.executives.length;
            });
            return total;
        },

        // Search functionality
        filteredExecutives() {
            if (!this.searchQuery.trim()) {
                this.hierarchicalData = [...this.originalHierarchicalData];
                this.totalExecutives = this.calculateTotalExecutives();
                return;
            }

            const searchLower = this.searchQuery.toLowerCase();
            
            // Filter the original flat data first
            let filteredFlatData = this.originalExecutivesData.filter(executive => {
                const memberName = executive.member_name?.toLowerCase() || '';
                const mobile = executive.member_phone?.toLowerCase() || '';
                const designation = executive.designation?.toLowerCase() || '';
                const zoneName = executive.zone_name?.toLowerCase() || '';
                
                return memberName.includes(searchLower) || 
                       mobile.includes(searchLower) || 
                       designation.includes(searchLower) ||
                       zoneName.includes(searchLower);
            });
            
            // Filter out regular "Member" entries - only show Executive Members
            filteredFlatData = this.filterExecutiveMembersOnly(filteredFlatData);
            
            // Transform filtered data back to hierarchical structure
            this.hierarchicalData = this.transformToHierarchical(filteredFlatData);
            this.totalExecutives = filteredFlatData.length;
        },

        // Filter event handlers
        onWingChange(wing) {
            this.filters.wing = wing;
            this.filters.department = '';
            
            // Clear existing data immediately
            this.executivesData = {
                data: [],
                total: 0,
                per_page: 10,
                current_page: 1,
                from: 0,
                to: 0
            };
            this.hierarchicalData = [];
            this.originalExecutivesData = [];
            this.totalExecutives = 0;
            
            this.loading = true;
            this.executivesLoading = true;
            
            this.loadDepartmentsList();
            this.loadExecutivesList(1);
        },

        async onDistrictChange() {
            // State admin only: selecting district should refresh zones list and reset zone selection
            this.filters.zone = '';
            this.filters.position = '';
            this.filters.department = '';
            
            if (this.currentUser && parseInt(this.currentUser.user_level) === 1) {
                await this.loadZonesList(this.filters.district || null);
                await this.loadDepartmentsList();
                this.loadExecutivesList(1);
            }
        },

        onZoneChange() {
            this.filters.department = '';
            this.loadDepartmentsList();
        },

        onDepartmentChange() {
            // Don't apply filters automatically - wait for user to click Filter button
        },

        applyFilters() {
            // If we don't have original data loaded, reload from API
            if (!this.originalExecutivesData || this.originalExecutivesData.length === 0) {
                this.loadExecutivesList(1);
                return;
            }
            
            console.log('applyFilters called - Filters:', this.filters);
            console.log('originalExecutivesData sample:', this.originalExecutivesData[0]);
            
            // Apply client-side filters to the original data
            let filteredData = [...this.originalExecutivesData];
            
            // Filter by zone
            if (this.filters.zone) {
                filteredData = filteredData.filter(executive => 
                    executive.zone_id == this.filters.zone
                );
            }

            // Filter by district (State Admin)
            if (this.filters.district) {
                filteredData = filteredData.filter(executive =>
                    executive.district_id == this.filters.district
                );
            }
            
            // Filter by position
            if (this.filters.position) {
                const selectedPosition = this.positionsList.find(pos => pos.id === this.filters.position);
                console.log('Filter by position - Selected:', selectedPosition);
                if (selectedPosition) {
                    filteredData = filteredData.filter(executive => {
                        const designation = executive.designation || executive.user_sublevel_desc || '';
                        const isStateCouncillor = designation && designation.toLowerCase().includes('state councillor');
                        
                        // Console log for State Councillor entries
                        if (isStateCouncillor) {
                            console.log('State Councillor in filter:', {
                                id: executive.id,
                                name: executive.member_name,
                                designation: designation,
                                user_sublevel_desc: executive.user_sublevel_desc,
                                comments: executive.comments,
                                selectedPositionValue: selectedPosition.value,
                                matches: designation === selectedPosition.value
                            });
                        }
                        
                        return designation === selectedPosition.value;
                    });
                    console.log('After position filter, filteredData length:', filteredData.length);
                }
            }
            
            // Filter by department - use exact matching to avoid "Education" matching "Informal Education"
            if (this.filters.department) {
                const selectedDepartment = this.departmentsList.find(dept => dept.id == this.filters.department);
                if (selectedDepartment) {
                    filteredData = filteredData.filter(executive => {
                        const departments = executive.departments || '';
                        if (!departments) return false;
                        
                        // Handle both string (comma-separated) and array formats
                        let departmentArray = [];
                        if (typeof departments === 'string') {
                            // Split by comma and clean up
                            departmentArray = departments.split(',').map(d => d.trim().toLowerCase()).filter(d => d && d !== 'none');
                        } else if (Array.isArray(departments)) {
                            // If it's an array, extract names
                            departmentArray = departments.map(dept => {
                                const name = typeof dept === 'string' ? dept : (dept.name || dept.name_mal || '');
                                return name.trim().toLowerCase();
                            }).filter(d => d);
                        }
                        
                        const selectedNameLower = selectedDepartment.name?.trim().toLowerCase() || '';
                        const selectedNameMalLower = selectedDepartment.name_mal?.trim().toLowerCase() || '';
                        
                        // Check for exact match in the department list
                        return departmentArray.some(dept => 
                            dept === selectedNameLower || dept === selectedNameMalLower
                        );
                    });
                }
            }
            
            // Apply search filter if there's a search query
            if (this.searchQuery && this.searchQuery.trim()) {
                const searchLower = this.searchQuery.toLowerCase();
                filteredData = filteredData.filter(executive => {
                    const memberName = executive.member_name?.toLowerCase() || '';
                    const mobile = executive.member_phone?.toLowerCase() || '';
                    const designation = executive.designation?.toLowerCase() || '';
                    const zoneName = executive.zone_name?.toLowerCase() || '';
                    
                    return memberName.includes(searchLower) || 
                           mobile.includes(searchLower) || 
                           designation.includes(searchLower) ||
                           zoneName.includes(searchLower);
                });
            }
            
            // Filter out regular "Member" entries - only show Executive Members
            filteredData = this.filterExecutiveMembersOnly(filteredData);
            
            // Update the displayed data
            this.executivesData.data = filteredData;
            this.executivesData.total = filteredData.length;
            this.executivesData.to = filteredData.length;
            this.hierarchicalData = this.transformToHierarchical(filteredData);
            this.totalExecutives = filteredData.length;
        },

        clearFilters() {
            this.filters = {
                wing: '1',
                district: '',
                zone: '',
                position: '',
                department: ''
            };
            this.searchQuery = '';

            // For State Admins, clearing district should restore full zone list + data
            if (this.currentUser && parseInt(this.currentUser.user_level) === 1) {
                this.loadZonesList(null);
                this.loadDepartmentsList();
                this.loadExecutivesList(1);
                return;
            }
            
            // Restore original data immediately
            if (this.originalExecutivesData && this.originalExecutivesData.length > 0) {
                this.executivesData.data = [...this.originalExecutivesData];
                this.executivesData.total = this.originalExecutivesData.length;
                this.executivesData.to = this.originalExecutivesData.length;
                this.hierarchicalData = this.transformToHierarchical(this.originalExecutivesData);
                this.totalExecutives = this.originalExecutivesData.length;
                
                this.populateFilterDropdownsFromData(this.originalExecutivesData);
            } else {
                this.loadExecutivesList(1);
            }
        },

        // Pagination methods
        onPaginationClick(page) {
            if (this.isClientSidePagination && this.allComprehensiveData.length > 0) {
                // Handle client-side pagination
                const perPage = this.executivesData.per_page;
                const startIndex = (page - 1) * perPage;
                const endIndex = startIndex + perPage;
                const pageData = this.allComprehensiveData.slice(startIndex, endIndex);
                
                this.executivesData = {
                    ...this.executivesData,
                    data: pageData,
                    current_page: page,
                    from: startIndex + 1,
                    to: Math.min(endIndex, this.allComprehensiveData.length)
                };
                
                this.hierarchicalData = this.transformToHierarchical(pageData);
            } else {
                // Handle server-side pagination
                this.loadExecutivesList(page);
            }
        },

        refreshExecutives() {
            this.loadExecutivesList(1);
        },

        shareViaWhatsApp() {
            try {
                // Get current wing name
                const wingName = this.getWingName(this.filters.wing || '1');
                
                // Build the share text
                let shareText = `*${this.$t('zone_level_executives')} - ${wingName}*\n\n`;
                
                // Add filter information if any filters are active
                const activeFilters = [];
                if (this.filters.district) {
                    const selectedDistrict = this.districtsList.find(d => d.id == this.filters.district);
                    if (selectedDistrict) {
                        activeFilters.push(`District: ${selectedDistrict.name}`);
                    }
                }
                if (this.filters.zone) {
                    const selectedZone = this.zonesList.find(z => z.id == this.filters.zone);
                    if (selectedZone) {
                        activeFilters.push(`Zone: ${selectedZone.name}`);
                    }
                }
                if (this.filters.position) {
                    const selectedPosition = this.positionsList.find(pos => pos.id === this.filters.position);
                    if (selectedPosition) {
                        activeFilters.push(`Designation: ${selectedPosition.value_mal || selectedPosition.value}`);
                    }
                }
                if (this.filters.department) {
                    const selectedDepartment = this.departmentsList.find(dept => dept.id == this.filters.department);
                    if (selectedDepartment) {
                        activeFilters.push(`Department: ${selectedDepartment.name_mal || selectedDepartment.name}`);
                    }
                }
                
                if (activeFilters.length > 0) {
                    shareText += `*Filters:* ${activeFilters.join(', ')}\n\n`;
                }
                
                shareText += `*Total: ${this.totalExecutives} ${this.$t('executives')}*\n\n`;
                shareText += `━━━━━━━━━━━━━━━━━━━━\n\n`;
                
                // Add executive details
                let executiveCount = 0;
                this.hierarchicalData.forEach((zone, zoneIndex) => {
                    if (zoneIndex > 0) {
                        shareText += `\n`;
                    }
                    
                    shareText += `*${zone.name}*\n\n`;
                    
                    zone.executives.forEach((executive) => {
                        executiveCount++;
                        shareText += `${executiveCount}. *${executive.member ? executive.member.name : 'N/A'}*\n`;
                        
                        // Add designation
                        if (executive.user_sublevel_desc) {
                            shareText += `   ${executive.user_sublevel_desc}\n`;
                        }
                        
                        // Add contact info if visible
                        if (this.shouldShowContactInfo(executive)) {
                            if (executive.member && executive.member.mobile) {
                                shareText += `   📞 ${executive.member.country_code} ${executive.member.mobile}\n`;
                            }
                            if (executive.member && executive.member.whatsapp_number) {
                                shareText += `   💬 WhatsApp: ${executive.member.whatsapp_country_code || executive.member.country_code} ${executive.member.whatsapp_number}\n`;
                            }
                        }
                        
                        // Add departments
                        if (executive.departments && executive.departments.length > 0) {
                            const deptNames = executive.departments.map(dept => dept.name_mal || dept.name).join(', ');
                            shareText += `   📋 ${deptNames}\n`;
                        }
                        
                        shareText += `\n`;
                    });
                });
                
                shareText += `━━━━━━━━━━━━━━━━━━━━\n`;
                shareText += `*Generated from Wisdom Guide App*\n`;
                
                // Encode the text for URL
                const encodedText = encodeURIComponent(shareText);
                
                // Create WhatsApp share URL
                const whatsappUrl = `https://wa.me/?text=${encodedText}`;
                
                // Open WhatsApp in new window/tab
                window.open(whatsappUrl, '_blank');
                
            } catch (error) {
                console.error('Error sharing via WhatsApp:', error);
                alert('Failed to share. Please try again.');
            }
        },

        getWingName(wing) {
            const wingNames = {
                '1': this.$t('wisdom'),
                '2': this.$t('youth'),
                '3': this.$t('students'),
                '4': this.$t('women'),
                '5': this.$t('balavedi'),
                '6': this.$t('girls')
            };
            return wingNames[wing] || 'Unknown';
        }
    }
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
    font-size: 12px;
    line-height: 1.3;
    padding-top: 2px;
    margin-top: 2px;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 700;
    margin-right: 8px;
    font-size: 13px;
    min-width: 20px;
}

.image-listview.text>li:after {
    left: 0px;
    background-color: #1a418c;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: bold;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.avatar-section .abroad {
    background: #0962d2;
}

.avatar-section .payment-verified {
    background: #05d0a4;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.09);
    border-radius: 10px;
    padding: 10px 10px;
}

.stat-box .btn-success {
    background-color: #25D366;
    border-color: #25D366;
    color: white;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 6px;
}

.stat-box .btn-success:hover {
    background-color: #20BA5A;
    border-color: #20BA5A;
    color: white;
}

.stat-box .btn-success ion-icon {
    font-size: 18px;
}

/* Tab Navigation Styling */
.nav-link.active {
    background-color: #007bff;
    color: white;
}

.action .btn-sm {
    height: auto;
    width: auto;
    margin-right: 5px;
}

/* Zone Separators - Compact */
.zone-section {
    margin-bottom: 10px;
}

.zone-header {
    position: relative;
    padding: 0 8px;
}

.zone-bottom-separator {
    height: 1px;
    background: #e9ecef;
    margin: 10px 0;
    border-radius: 1px;
}

/* Enhanced listview styling - Compact */
.zone-section .listview {
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0,0,0,0.08);
    margin-bottom: 4px;
}

.zone-section .listview li:first-child .item {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.zone-section .listview li:last-child .item {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}

/* Reduce padding in list items */
.zone-section .listview .item {
    padding: 8px 12px;
    min-height: auto;
}

.zone-section .listview .item .in {
    padding-left: 8px;
}

/* Compact avatar sizing */
.zone-section .avatar-section .image {
    width: 38px;
    height: 38px;
}

/* Mobile-specific optimizations */
@media (max-width: 768px) {
    .zone-section {
        margin-bottom: 8px;
    }
    
    .zone-header .listview-title {
        font-size: 14px !important;
        margin-top: 6px !important;
        margin-bottom: 4px !important;
        padding: 0 4px;
    }
    
    .zone-section .listview .item {
        padding: 6px 10px;
    }
    
    .zone-section .listview .item .in {
        padding-left: 6px;
    }
    
    .zone-section .avatar-section .image {
        width: 34px;
        height: 34px;
    }
    
    .listview>li footer {
        font-size: 11px;
        line-height: 1.2;
        padding-top: 1px;
    }
    
    .min-width-50 {
        min-width: 55% !important;
    }
    
    .sl-no {
        font-size: 12px;
        margin-right: 6px;
    }
}

@media print {
    .section:first-child, .action, #search {
        display: none !important;
    }
    
    .listview>li {
        break-inside: avoid;
        page-break-inside: avoid;
    }
    
    .zone-section {
        break-inside: avoid;
        page-break-inside: avoid;
    }
}
</style>

